import { deleteApiRequest } from 'api';

export const deleteAttendanceMark = async (markId: number): Promise<unknown> => {
    return await deleteApiRequest(`/mark-attendance-lesson/delete/${markId}/`);
};
